import { Component, OnInit } from '@angular/core';
import { ApplicationInsightsService } from '../../services/application-insights/application-insights.service';
import { SharedDataService } from '../../services/shared-data/shared-data.service';
import * as model from '../../../model/model';
import { MyActionItemDto } from '../../../model/modelDto';
import { UnitOfWorkService } from '../../services/unit-of-work/unit-of-work.service';
import { GlobalErrorHandler } from '../../services/global-error-handler';

@Component({
    selector: 'app-home-screen',
    templateUrl: './home-screen.component.html',
    styleUrls: ['./home-screen.component.less'],
    standalone: false
})
export class HomeScreenComponent implements OnInit {
    actionItems: MyActionItemDto[] = [];
    isLoadingActionItems = false;

    constructor(
        private appInsights: ApplicationInsightsService,
        private sharedData: SharedDataService,
        private uow: UnitOfWorkService,
        private errorHandler: GlobalErrorHandler
    ) {
        appInsights.logPageView();
    }

    ngOnInit() {
        this.loadActionItems();
    }

    loadActionItems(): Promise<void> {
        this.isLoadingActionItems = true;
        return this.uow.getMyActionItems()
            .then(result => {
                this.actionItems = result || [];
            })
            .catch(reason => this.errorHandler.handleError(reason))
            .finally(() => this.isLoadingActionItems = false);
    }

    isDateDueSoon(value: Date | string | null): boolean {
        const dateKey = this.getDateKey(value);
        if (dateKey === null) {
            return false;
        }

        const today = new Date();
        const todayKey = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
        const fiveDaysFromTodayKey = todayKey + (5 * 24 * 60 * 60 * 1000);

        return dateKey >= todayKey && dateKey <= fiveDaysFromTodayKey;
    }

    get me(): model.Employee {
        return this.sharedData.me.value;
    }

    get isAdmin(): boolean {
        return this.me ? this.me.isAdmin : false;
    }

    get isTeamCaptain(): boolean {
        return this.me ? this.me.isNationalQcAdmin : false;
    }

    get isInspectorOnly(): boolean {
        return this.me ? !this.me.isAdmin && !this.me.isNationalQcAdmin : false;
    }

    get showInspectorLinks(): boolean {
        return this.isInspectorOnly || this.isAdmin;
    }

    get showTeamCaptainLinks(): boolean {
        return this.isTeamCaptain || this.isAdmin;
    }

    private getDateKey(value: Date | string | null): number | null {
        if (!value) {
            return null;
        }

        if (typeof value === 'string') {
            const dateOnly = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
            if (dateOnly) {
                return Date.UTC(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]));
            }
        }

        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) {
            return null;
        }

        return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    }
}
